import { Link } from 'react-router-dom';
import { FiCalendar, FiBox, FiPhone, FiTruck } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { getLocalized } from '../../utils/i18nHelpers';
import { SlideUp, StaggerContainer, StaggerItem } from '../animations';

const ExperienceSection = ({ settings }) => {
    const { i18n, t } = useTranslation();
    const defaultExperiences = [
        {
            id: 1,
            title: t('home.experience.item1Title'),
            desc: t('home.experience.item1Desc'),
            link: "/contact",
            linkText: t('home.experience.item1Link')
        },
        {
            id: 2,
            title: t('home.experience.item2Title'),
            desc: t('home.experience.item2Desc'),
            link: "/shipping",
            linkText: t('home.experience.item2Link')
        },
        {
            id: 3,
            title: t('home.experience.item3Title'),
            desc: t('home.experience.item3Desc'),
            link: "/contact",
            linkText: t('home.experience.item3Link')
        },
        {
            id: 4,
            title: t('home.experience.item4Title'),
            desc: t('home.experience.item4Desc'),
            link: "/packaging",
            linkText: t('home.experience.item4Link')
        }
    ];

    const experiences = settings?.experienceItems || defaultExperiences;

    const getIcon = (index) => {
        const icons = [
            <FiCalendar key={1} className="w-6 h-6 stroke-[1.5]" />, 
            <FiTruck key={2} className="w-6 h-6 stroke-[1.5]" />, 
            <FiPhone key={3} className="w-6 h-6 stroke-[1.5]" />, 
            <FiBox key={4} className="w-6 h-6 stroke-[1.5]" />
        ];
        return icons[index % icons.length];
    };

    return (
        <section className="py-16 md:py-24 bg-[#fafafa]">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
                {/* Header */}
                <SlideUp className="text-center mb-20">
                    <span className="block text-[#287968] text-[10px] md:text-[11px] font-bold tracking-[0.25em] uppercase mb-4">{t('home.experience.subtitle')}</span>
                    <h2 className="text-4xl md:text-5xl font-serif text-[#4a4a4a] mb-6">
                        {getLocalized(settings, 'experienceTitle', i18n.language) || t('home.experience.title')}
                    </h2>
                    <div className="w-12 h-[1px] bg-gray-300 mx-auto"></div>
                </SlideUp>

                {/* Grid */}
                <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 text-center">
                    {experiences.map((item, index) => (
                        <StaggerItem key={index} className="flex flex-col items-center group">
                            {/* Circular Icon */}
                            <div className="w-20 h-20 rounded-full border border-gray-200 flex items-center justify-center mb-8 text-[#2b303b] bg-white group-hover:border-[#45b59c] group-hover:text-[#45b59c] transition-colors duration-300">
                                {getIcon(index)}
                            </div>
                            
                            <h3 className="text-sm font-semibold tracking-[0.15em] uppercase text-[#4a4a4a] mb-4">
                                {getLocalized(item, 'title', i18n.language)}
                            </h3>
                            
                            <p className="text-gray-500 text-xs leading-loose mb-8 max-w-[220px] mx-auto min-h-[60px]">
                                {getLocalized(item, 'desc', i18n.language)}
                            </p>
                            
                            <Link
                                to={item.link || '#'}
                                className="text-[10px] font-bold tracking-[0.2em] text-[#2b303b] uppercase hover:text-[#45b59c] transition-colors"
                            >
                                {getLocalized(item, 'linkText', i18n.language)}
                            </Link>
                        </StaggerItem>
                    ))}
                </StaggerContainer>
            </div>
        </section>
    );
};

export default ExperienceSection;
